// eslint-disable-next-line
var manifest = require('./manifest.json');
/**
 * Build the URL for an icon.
 * @param {string} name
 *   The name of one of our SVG icons.
 * @param {string} theme
 *   The name of one of the themes in the themes package.
 * @param {string} publicPath
 *   The public path from which icons are served.
 */


export default (function (name, theme) {
  var publicPath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var hash = manifest.hash,
      icons = manifest.icons;

  if (!(name in icons)) {
    throw new Error("No icon with name \"".concat(name, "\" could be found in the icons manifest."));
  }

  if (!theme) {
    throw new Error('A theme must be provided so we can establish any overrides');
  }

  var icon = icons[name];
  var hasOverride = icon.overrides.includes(theme);
  var iconBasePath = hasOverride ? "overrides/".concat(theme) : 'base';
  var publicBasePath = "".concat(publicPath || '', "/").concat(iconBasePath).replace(/\/\//g, '/');

  var _URL = new URL("".concat(publicBasePath, "/sprite-maps/").concat(icon.groupName, "-").concat(hash, ".svg"), 'http://temp'),
      spriteMapPathName = _URL.pathname;

  return spriteMapPathName.concat("#".concat(name));
});